import React from 'react';
import Image from '@react/shared/Image';
const BlogCard = ({ title, image, url, authorName, authorImage, pinText, openInNewTab, }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card card--reports card--small-ver", target: openInNewTab ? '_blank' : '_self', rel: "noreferrer" },
        React.createElement("div", { className: "card__inner" },
            React.createElement("div", { className: "card__media" },
                React.createElement("div", { className: "card__media-holder" },
                    React.createElement(Image, { image: image, alt: title, ratio: 1, width: 460, className: "card__media-element", cdn: true }))),
            React.createElement("div", { className: "card__content-external" },
                React.createElement("div", { className: "tag tag--black" }, pinText),
                React.createElement("div", { className: "card__content-internal" },
                    authorImage !== '/' && (React.createElement(Image, { image: authorImage, alt: authorName, ratio: 1, width: 372, className: "card__report-logo", cdn: true })),
                    React.createElement("h3", { className: "card__title" }, title)))))));
export default BlogCard;
